import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 383.947 383.947"
      version="1.1"
      viewBox="0 0 383.947 383.947"
      xmlSpace="preserve"
    >
      <path d="M0 303.947L0 383.947 80 383.947 316.053 147.893 236.053 67.893z"></path>
      <path d="M377.707 56.053L327.893 6.24c-8.32-8.32-21.867-8.32-30.187 0l-39.04 39.04 80 80 39.04-39.04c8.321-8.32 8.321-21.867.001-30.187z"></path>
    </svg>
  );
}

export default Icon;
